import React, {memo} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const PageTitle = memo((props) => {

	const localStyles = {
		pageTitle: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'flex-start',
			maxWidth: {sm: '800px'}
		},
		withPaper: {
			marginTop: 0,
			marginBottom: {xs: 1, sm: 3},
		},
		withoutPaper: {
			marginTop: {xs: 1, sm: 0},
			marginBottom: {xs: 2, sm: 3},
		}
	}
	
	return (
	<Box component='div' 
		sx={props.withoutPaper ? {...localStyles.pageTitle, ...localStyles.withoutPaper} : {...localStyles.pageTitle, ...localStyles.withPaper}}
	>
		<Typography variant="h2" component="h1">{props.title}</Typography>
		{props.other ? props.other : null}
	</Box>
)});

export default PageTitle;